import { createContext } from 'react'
import { sessIdType } from '../sharedF/sessIdTypeF.mts'

export const SessIdCtx = createContext<{sessId: sessIdType | undefined, setSessId: (sessId: sessIdType) => void} | undefined>(undefined)